import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";



const initialState = {
    form: {},
    currentPage: 1,
    keterangan: null,
    urutan: {
        column: 'nama',
        order: 'asc'
    },
    search: '',

    judul: '',


    errors: {
        nama: '',
        email: '',
        password: '',
        kelas: '',
    },

    isInitialGet: false,
    statusResApi: '',
    messageResApi: '',
    isDisplayMessage: false,

    isLoading: true,
    isLoadingTambahSoal: false,
};

export const getBuatSoal = createAsyncThunk("buatSoal/getBuatSoal", async ({ search }, { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/form',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    search
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

export const tambahSoal = createAsyncThunk("buatSoal/tambahSoal", async ({ question, choices }, { rejectWithValue }) => {
    try {
        const response = await axios.post(
            getBaseUrl + '/api/form',
            { question, choices },
            {
                headers: { Authorization: `Bearer ${token()}` },
                timeout: 20000,
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled')
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout')
        return rejectWithValue(error.message)
    }
})

export const hapusPertanyaan = createAsyncThunk("buatSoal/hapusPertanyaan", async (id, { rejectWithValue }) => {
    try {
        const response = await axios.delete(
            getBaseUrl + `/api/form/${id}`,
            {
                headers: { Authorization: `Bearer ${token()}` },
                timeout: 20000,
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) throw new Error('Request canceled')
        if (error.code === 'ECONNABORTED') return rejectWithValue('Request timeout')
        return rejectWithValue(error.message)
    }
})

export const updateJudulBuatSoal = createAsyncThunk("buatSoal/updateJudulBuatSoal", async ({ nama_form }, { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/form/ganti-judul',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    nama_form
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})




const buatSoalSlice = createSlice({
    name: 'jadwalguru',
    initialState,
    reducers: {




        updateStateBuatSoal: (state, action) => {

            const { name, value } = action.payload
            state[name] = value
        },




    },
    extraReducers: (builder) => {
        builder
            .addCase(getBuatSoal.pending, (state) => {
                console.log("halo mo")
                state.isLoading = true;
            })
            .addCase(getBuatSoal.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoading = false;
                state.form = action.payload.data;
                state.judul = action.payload.data.form.nama_form;
                state.isInitialGet = true
            })
            .addCase(getBuatSoal.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })


            .addCase(tambahSoal.pending, (state) => {
                state.isLoadingTambahSoal = true
            })
            .addCase(tambahSoal.fulfilled, (state) => {
                state.isLoadingTambahSoal = false
            })
            .addCase(tambahSoal.rejected, (state, action) => {
                state.isLoadingTambahSoal = false
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

            .addCase(hapusPertanyaan.pending, (state) => {
                state.isLoading = true
            })
            .addCase(hapusPertanyaan.fulfilled, (state) => {
                state.isLoading = false
            })
            .addCase(hapusPertanyaan.rejected, (state, action) => {
                state.isLoading = false
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

            .addCase(updateJudulBuatSoal.pending, (state) => {
                console.log("halo mo")
                state.isLoading = true;
            })
            .addCase(updateJudulBuatSoal.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoading = false;
                state.isInitialGet = true
            })
            .addCase(updateJudulBuatSoal.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })


    }
});

export const {
    updateFieldValue, updateFieldError, resetForm, updateClassSiswa, setFormLoading, resetField, resetTable,
    setImgUpload, updateStateMonitorKelas, deleteKelas, updateStateBuatSoal, resetListSiswa, showFormError
} = buatSoalSlice.actions;
export default buatSoalSlice.reducer;